import { useQueryClient } from "@tanstack/react-query";
import { createContext, useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import queryKey from "../../../enumerations/queryKey";
import { useSearchGame } from "../../../hooks/searchGame/searchGame.hook";
import SearchPopup from "../components/SearchPopup";

const SearchContext = createContext({
  showSearchPopup: false,
  setShowSearchPopup: () => {},
  selectedGame3th: { game_3th_code: "search_all" },
  setSelectedGame3th: () => {},
  setEnablePopup: () => {},
  searchValue: "",
  setSearchValue: () => {},
  searchResult: undefined,
  searchError: false,
  hasNextPage: false,
  fetchNextPage: () => {},
  isFetchingNextPage: false,
  searchResultByGameCategoryCode: undefined,
  searchErrorByGameCategoryCode: false,
  hasNextPageByGameCategoryCode: false,
  fetchNextPageByGameCategoryCode: () => {},
  isFetchingNextPageByGameCategoryCode: false,
});

export const SearchContextProvider = ({ children }) => {
  const { state } = useLocation();
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const location = useLocation();
  const [showSearchPopup, setShowSearchPopup] = useState(false);
  const [selectedGame3th, setSelectedGame3th] = useState({ game_3th_code: "search_all" });
  const [selectedGameCategoryCode, setSelectedGameCategoryCode] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [enablePopup, setEnablePopup] = useState(true);

  const handleQueryEnable = () => {
    if (enablePopup) {
      return showSearchPopup;
    } else {
      return true;
    }
  };

  useEffect(() => {
    if (state) {
      if (state?.isPopup && state?.isPopup === true) {
        // console.debug("state", state);
        setSelectedGame3th({ game_3th_code: state?.game_3th_code });
        setShowSearchPopup(true);
        window.history.replaceState({}, document.title);
      }
    }
  }, [state]);

  useEffect(() => {
    // Reset infinite-query pages when switching brand.
    // This ensures switching back starts from page 1 instead of cached page N.
    if (!showSearchPopup) {
      queryClient.removeQueries({ queryKey: [queryKey.SEARCH_GAME] });
    }
  }, [showSearchPopup, selectedGame3th?.game_3th_code, queryClient]);

  const {
    data: searchResult,
    isError: searchError,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage,
  } = useSearchGame(
    {
      enabled: handleQueryEnable(),
      getNextPageParam: (lastPage, pages) => {
        if (pages.length < lastPage?.last_page) {
          return pages.length + 1;
        } else {
          return undefined;
        }
      },
    },
    {
      keyword: searchValue,
      game_3th_code:
        selectedGame3th.game_3th_code === "search_all" ? "" : selectedGame3th.game_3th_code,
      game_category_code: selectedGameCategoryCode,
      page_size: 20,
    },
  );
  useEffect(() => {
    if (searchResult) {
      // console.debug("searchResult", searchResult);
    }
  }, [searchResult]);

  return (
    <SearchContext.Provider
      value={{
        showSearchPopup,
        setShowSearchPopup,
        selectedGame3th,
        setSelectedGame3th,
        setEnablePopup,
        searchValue,
        setSearchValue,
        searchResult,
        searchError,
        hasNextPage,
        fetchNextPage,
        isFetchingNextPage,
        setSelectedGameCategoryCode,
      }}
    >
      {children}
      <SearchPopup
        visible={showSearchPopup}
        onClose={() => {
          setShowSearchPopup(false);
        }}
        game3thCode={selectedGame3th.game_3th_code}
        setSearchValue={setSearchValue}
        searchResult={searchResult}
        searchError={searchError}
        hasNextPage={hasNextPage}
        fetchNextPage={fetchNextPage}
        isFetchingNextPage={isFetchingNextPage}
      />
    </SearchContext.Provider>
  );
};
export const useSearch = () => {
  const SearchValue = useContext(SearchContext);
  return SearchValue;
};
